import firebaseConfigs from "firebaseConfigs.json";

// The Nutivate-owned Firebase project's web settings for this build's environment, or undefined when none is set
// yet, which turns push notifications off. The push service worker gets the same settings through
// scripts/write-firebase-config.js.
const firebaseConfig = firebaseConfigs[process.env.REACT_APP_ENV || "development"] || undefined;

export default firebaseConfig;
